'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentKbcAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M51.2964 16.7C51.2964 21.911 47.093 26.15 41.9257 26.15C36.7584 26.15 32.555 21.911 32.555 16.7C32.555 11.489 36.7584 7.25 41.9257 7.25C47.093 7.25 51.2964 11.489 51.2964 16.7ZM39.8641 28.256C43.9069 28.256 47.0394 26.285 48.8332 24.341C59.4623 23.774 68.7527 23.828 68.7527 23.828V32.441H14.4828V28.256C14.4828 28.256 22.0864 26.744 32.3139 25.664C34.0274 27.041 36.7316 28.256 39.8641 28.256Z",
          fill: "#00AEEF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M63.4515 49.937C65.2186 49.937 67.2266 49.64 68.7527 49.181V44.564C67.4675 45.32 66.1824 45.806 64.3886 45.806C62.0057 45.806 59.6497 44.618 59.6497 42.917C59.6497 41.216 62.0325 40.028 64.3886 40.028C66.2092 40.028 67.4943 40.514 68.7527 41.297V36.653C67.0392 36.086 64.8437 35.897 63.1302 35.897C56.9455 35.897 52.394 37.976 52.394 42.782C52.394 48.101 57.0794 49.937 63.4515 49.937ZM20.9352 44.672V49.748H14.4828V36.221H20.9352V42.296H20.962L24.7638 36.221H32.5013L26.8254 43.214L32.1801 49.748H24.7906L20.962 44.672H20.9352ZM33.5456 36.221H46.5843C49.9578 36.221 51.0823 37.544 51.0823 39.623C51.0823 41.945 49.0207 42.944 46.9324 43.052V43.079C49.101 43.241 51.1894 43.484 51.1894 46.238C51.1894 48.02 50.0917 49.775 46.3434 49.775H33.5456V36.221ZM39.998 46.994H43.3714C44.6298 46.994 45.0582 46.481 45.0582 45.698C45.0582 44.915 44.6298 44.375 43.3714 44.375H39.998V46.994ZM43.2108 41.945H39.998V39.326H43.3179C44.4691 39.326 44.9511 39.758 44.9511 40.649C44.9511 41.432 44.4424 41.945 43.2108 41.945Z",
          fill: "#003665"
        }
      )
    ]
  }
);
const VpPaymentKbcAsset = forwardRef(PaymentKbcAsset);

export { VpPaymentKbcAsset as default };
